import { JsonApi } from '@/_type/json'
import { openDialog } from '@/_components/dialog/dialog'
import { isEqual } from 'lodash'

export default class EditorJS {
    public readonly _type: 'text' | 'editorjs'
    public textData: null | string = null
    public editorjsTime: null | string = null
    public editorjsVersion: null | string = null
    public editorjsBlocks: null | Array<Record<string, any>> = null

    public constructor(data) {
        this._type = data.type

        if (this._type == 'text') {
            this.textData = data.data
        } else if ((this._type = 'editorjs')) {
            this.editorjsTime = data.data.time
            this.editorjsVersion = data.data.version
            this.editorjsBlocks = data.data.blocks
        }
    }

    renderDifference(oldVal: EditorJS) {
        // if(this._type == 'editorjs' && oldVal._type == 'editorjs'){

        //     // return this.editorjsBlocks?.map((block, index) => {
        //     //     return this.renderBlock(block, oldVal.editorjsBlocks? oldVal.editorjsBlocks[index] : null)
        //     // }).join('')

        // }
        return this.renderAll
    }

    get renderAll() {
        if (this._type == 'text') {
            return `
                <p style='white-space: pre-wrap'>${this.textData}</p>
            `
        } else if (this._type == 'editorjs') {
            return this.editorjsBlocks?.map((block) => this.renderBlock(block)).join('')
        }
    }

    renderBlock(block, old?) {
        switch (block.type) {
            case 'paragraph':
                return old
                    ? this.renderParagraphDiff(block.data, old.data)
                    : this.renderParagraph(block.data)
            case 'header':
                return old
                    ? this.renderHeaderDiff(block.data, old.data)
                    : this.renderHeader(block.data)
            case 'list':
                return old
                    ? this.renderHeaderDiff(block.data, old.data)
                    : this.renderList(block.data)
            case 'delimiter':
                return old ? this.renderHeaderDiff(block.data, old.data) : this.renderDelimiter()

            case 'quote':
                return old
                    ? this.renderHeaderDiff(block.data, old.data)
                    : this.renderQuote(block.data)
            case 'table':
                return old
                    ? this.renderHeaderDiff(block.data, old.data)
                    : this.renderTable(block.data)
            default:
                return `<p>${block}</p>`
        }
    }

    renderParagraph(data: { text: string }) {
        return `
            <p>${data.text}</p>
        `
    }

    renderHeader(data: { text: string; level: number }) {
        return `
            <h${data.level}>${data.text}</h${data.level}>
        `
    }

    renderList(data: { items: Array<string>; style: 'unordered' | 'ordered' }) {
        return `
            <${data.style == 'unordered' ? 'ul' : 'ol'}>
                ${data.items.map((li) => this.renderLi(li)).join('')}
            </${data.style == 'unordered' ? 'ul' : 'ol'}>
        `
    }

    renderLi(li: string) {
        return `<li>${li}</li>`
    }

    renderDelimiter() {
        return `<hr class = 'editorjsDelimiter'></hr>`
    }

    renderQuote(data: { alignment: 'left' | 'right' | 'center'; caption: string; text: string }) {
        return `
        <p class='text-${data.alignment}'>${data.text}</p>
        <p class='text-caption'>${data.caption}</p>`
    }

    renderTable(data: { content: Array<Array<string>> }) {
        return `
        <table class='editorjsTable'>
            ${data.content.map((row, index) => this.renderTableRow(row, index == 0)).join('')}
        </table>        
       `
    }

    renderTableRow(row: Array<string>, isFirst: boolean) {
        return `
        <tr>
            ${row
                .map((cell) =>
                    isFirst ? this.renderTableHeader(cell) : this.renderTableData(cell)
                )
                .join('')}
        </tr>
        `
    }

    renderTableHeader(text: string) {
        return `
        <th>
        ${text}
        </th>
        `
    }

    renderTableData(text: string) {
        return `
        <td>
        ${text}
        </td>
        `
    }

    renderParagraphDiff(newVal: { text: string }, oldVal: { text: string }) {
        if (oldVal.text == newVal.text) {
            return this.renderParagraph(newVal)
        } else {
            return `<p class='removed-text'>${oldVal.text}</p><p class='added-text'>${newVal.text}</p>`
        }
    }

    renderHeaderDiff(
        newVal: { text: string; level: number },
        oldVal: { text: string; level: number }
    ) {
        if (isEqual(oldVal, newVal)) {
            return this.renderHeader(newVal)
        } else {
            return oldVal
                ? `<h${oldVal.level} class='removed-text'>${oldVal.text}</h${oldVal.level}>`
                : '' + newVal
                ? `<h${newVal.level} class='added-text'>${newVal.text}</h${newVal.level}>`
                : ''
        }
    }
}
